import { useFeatureFlags } from '@features/feature-flags';
import { FeatureFlagKey } from '@libs/constants';

/**
 * Whether a runtime feature flag is on for the current tenant.
 *
 * Fails closed: `false` while the flags are still loading or if the request
 * errors, so a gated nav entry or button never flashes into view only to
 * disappear once the real (probably-off) value arrives.
 */
export const useFeatureFlag = (flag: FeatureFlagKey): boolean => {
  const { data } = useFeatureFlags();
  return data?.[flag] ?? false;
};
